import React from "react";
import { cvar } from "../../utils";

export interface TauMeterProps {
  tau: number;
  conf: number;
}

/* τ-vs-confidence bar — green if conf met the threshold, amber otherwise. */
export function TauMeter({ tau, conf }: TauMeterProps): JSX.Element {
  const met = conf >= tau;
  const c = met ? "--green" : "--amber";
  return (
    <span
      className="tau"
      title={
        "Threshold τ=" +
        tau.toFixed(2) +
        " — calibrate to your firm's tolerance. Observed confidence: " +
        conf.toFixed(2) +
        "."
      }
    >
      <span className="tert">τ{tau.toFixed(2)}</span>
      <span className="meter">
        <span className="fl" style={{ width: conf * 100 + "%", background: cvar(c) }} />
        <span className="mk" style={{ left: tau * 100 + "%" }} />
      </span>
      <span style={{ color: cvar(c) }}>{conf.toFixed(2)}</span>
    </span>
  );
}
